import * as React from 'react';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import FormInput from '../../../../common/form/Input';
import { DoorKingPropertyConfiguration } from '../../../../../api/PropertyIntegration';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

interface Props {
    config?: DoorKingPropertyConfiguration;
    update: (newConfig?: DoorKingPropertyConfiguration) => void;
}

const DoorKingConfigurationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();
    return(
    <CollapsibleCard
        cardTitle="DoorKing Front Door Access"
        cardOpen={!!props.config}
        onCardOpenChange={newValue => {
            if (isUser) return;props.update(newValue ? { deviceId: '' } : undefined)}}
    >
        <div>
            {props.config && (
                <>
                    <FormInput
                        labelProps={{
                            labelText: 'IoT Hub Device ID',
                            invalidText: 'Please enter the IOT Hub Device ID'
                        }}
                        inputProps={{
                            id: 'doorKing-client-id',
                            name: 'deviceId',
                            value: props.config.deviceId || '',
                            type: 'string',
                            required: true,
                            disabled: isUser
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({ ...props.config!, deviceId: value.toString() })
                        }
                    />
                </>
            )}
        </div>
    </CollapsibleCard>
);
};
export default DoorKingConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/DoorKingConfigurationSection.tsx